import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const containerStyles = css`
  display: flex;
  flex-wrap: wrap;
`;

export const inactiveStyles = css`
  opacity: 0.3;
`;

export const legendElementStyles = css`
  display: block;
`;

export const extraMarginStyles = css`
  margin-top: 16px;
`;

export const valueContainerStyles = css`
  display: flex;
  align-items: flex-end;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-size: 24px;
  font-weight: 600;
  margin-top: 4px;
  margin-bottom: 2px;
  white-space: nowrap;
`;

export const colorShapeStyles = css`
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 4px;
  margin-top: 5px;
  flex: 0 0 auto;
`;

export const nameStyles = css`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  max-width: 100%;
`;

export const namePartStyles = css`
  font-size: 12px;
  line-height: 16px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const singleSeriesContainer = css`
  padding-right: 32px;
  margin-bottom: 16px;
  position: relative;
  width: 25%;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    width: 33.3333%;
  }

  @media (max-width: 991px) {
    width: 50%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const headerStyles = css`
  display: flex;
`;

export const labelStyles = css`
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  font-size: 14px;
  line-height: 21px;
  margin-left: 6px;
  font-weight: 400;
`;
